(function(angular){
	'use strict';
	
	angular.module('navModule', [
		'ngCookies'
	]);

})(window.angular);